import React, { useEffect, useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Input, message, Modal, Form } from "antd";
import { ListItem } from "../common/index.jsx";
import buyDealAPI, { useWalkIn } from "@/service/buy-deal";
import { RightOutlined } from "@ant-design/icons";
import classNames from "classnames";
import moment from "moment";
import "./index.less";
import orderVoucherImg from "../images/order_voucher.svg";

// 新窗口-选择优惠券-添加优惠券
export const VoucherSelector = (props) => {
  const { t } = useTranslation();
  const { voucherCodes, deal_id, restaurant_id, project } = props;
  const [visible, setVisible] = useState(false);
  const [voucherRule, setVoucherRule] = useState({
    required: false,
    points_range: [],
  });
  const [voucherList, setVoucherList] = useState([]);

  const hasVoucher = useMemo(() => {
    return voucherList.filter((item) => item.applicable).length > 0;
  }, [voucherList]);

  const price = useMemo(() => {
    const size = voucherCodes.length;
    if (size === 0) return "";
    if (voucherList.length === 0) return "";
    if (size > 1) {
      return t("walkin.x vouchers", { size: size });
    }
    let { detail } = voucherList.find((item) => item.code === voucherCodes[0]);
    switch (detail.price_type) {
      case "percentage":
        return `-${detail.price}%`;
        break;
      case "fixed":
        return `${detail.currency}${detail.price_humanize}`;
        break;
      case "none":
        return detail.title;
        break;
      default:
        return detail.title;
        break;
    }
  }, [voucherCodes, voucherList]);

  /**
   * 获取优惠券使用规则
   * @returns
   */
  function getVoucherRule() {
    return buyDealAPI.getVoucherRule({
      deal_id: deal_id,
      restaurant_id: restaurant_id,
      project: project,
    });
  }
  /**
   * 获取优惠券列表
   * @returns
   */
  function getVoucherList() {
    return buyDealAPI.getVouchers({
      deal_id: deal_id,
      restaurant_id: restaurant_id,
      project: project,
    });
  }

  useEffect(() => {
    Promise.all([getVoucherRule(), getVoucherList()]).then((res) => {
      setVoucherRule(res[0]);
      setVoucherList(res[1]);
    });
  }, []);

  return (
    <React.Fragment>
      {visible && (
        <VoucherPopup
          setVisible={setVisible}
          voucherList={voucherList}
          getVoucherList={getVoucherList}
          voucherRule={voucherRule}
          {...props}
        ></VoucherPopup>
      )}
      <ListItem
        icon={orderVoucherImg}
        title={t("walkin.Voucher")}
        onClick={() => setVisible(true)}
        value={
          <span
            className="buydeal-voucher-item"
            data-disabled={hasVoucher ? false : true}
          >
            {hasVoucher ? (
              <React.Fragment>
                <span>{price ? price : t("walkin.Vouchers available")}</span>
                <RightOutlined style={{ fontSize: "12px", color: "#fff" }} />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>{t("walkin.No vouchers available")}</span>
                <RightOutlined style={{ fontSize: "12px", color: "#666" }} />
              </React.Fragment>
            )}
          </span>
        }
      ></ListItem>
    </React.Fragment>
  );
};

export const VoucherPopup = (props) => {
  const {
    setVisible,
    voucherCodes,
    setVoucherCodes,
    voucherRule,
    voucherList,
    getVoucherList,
  } = props;
  const { t } = useTranslation();
  const [visible, setAddModal] = useState(false);
  const [animate, setAnimate] = useState("in");
  const [values, setValues] = useState(voucherCodes || []);
  const [term, setTerm] = useState({
    visible: false,
    text: "",
  });
  const maxSize = voucherRule.required ? voucherRule.points_range[1] : 999;

  function onBack() {
    setAnimate("out");
    setTimeout(() => {
      setVisible(false);
    }, 250);
  }

  // 提交选中的券码
  function onConfirm() {
    setVoucherCodes(values);
    setVisible(false);
  }
  function onChange(data, val) {
    let list = [...values];
    if (val) {
      if (list.length < maxSize) {
        list.push(data.code);
      }
    } else {
      list = list.filter((item) => item !== data.code);
    }
    setValues(list);
  }
  return (
    <div className="buydeal-popup animate" data-animate={animate}>
      <div className="buydeal-popup-header">
        <div className="header-left" onClick={onBack}>
          <i className="icon icon-arrow-left"></i>
        </div>
        <strong>{t("VOUCHERS.My vouchers")}</strong>
        <span></span>
      </div>
      <div className="buydeal-popup-line"></div>
      <div className="buydeal-popup-body">
        {voucherRule.required && (
          <div className="buydeal-voucher-tip">
            <i className="icon icon-info selected"></i>
            <span>{t("walkin.You can use", { size: maxSize })}</span>
          </div>
        )}

        {voucherList.map((item, index) => {
          return (
            <VoucherCard
              key={index}
              onChange={(select) => onChange(item, select)}
              selected={values}
              {...item}
              showTerm={() => {
                setTerm({
                  visible: true,
                  text: item.detail.desc,
                });
              }}
            />
          );
        })}
        <Terms
          visible={term.visible}
          setVisible={() => setTerm((state) => ({ ...state, visible: false }))}
          text={term.text}
        />
      </div>
      <div className="buydeal-popup-footer">
        <div className="buydeal-popup-btn" onClick={() => setAddModal(true)}>
          {t("WEB.Enter code")}
        </div>
        <div className="buydeal-popup-btn primary" onClick={onConfirm}>
          {t("CONFIRM")}
        </div>
      </div>
      <AddVoucher
        visible={visible}
        setAddModal={setAddModal}
        onAdd={getVoucherList}
      />
    </div>
  );
};

export const AddVoucher = ({ visible, setAddModal, onAdd }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [str, setStr] = useState("");
  const [message, setMessage] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const onCancel = () => {
    form.resetFields();
    setStr("");
    setMessage("");
    setStatus("");
    setAddModal(false);
  };

  const onOk = () => {
    setConfirmLoading(true);
    buyDealAPI
      .addVoucher(form.getFieldValue("voucherStr"))
      .then((res) => {
        onAdd();
        onCancel();
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err?.data?.full_messages?.[0] || err.message);
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };
  return (
    <Modal
      className="loading-modal"
      zIndex={1011}
      title={t("WEB.Add voucher")}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width="420px"
      okText={t("CONFIRM")}
      cancelText={t("CANCEL")}
      okButtonProps={{ disabled: !str }}
      confirmLoading={confirmLoading}
    >
      <p>{t("WEB.Add voucher des")}</p>
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item name="voucherStr" validateStatus={status} help={message}>
          <Input
            placeholder={t("VOUCHERS.ENTER")}
            onChange={(e) => setStr(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const VoucherCard = (props) => {
  const { t } = useTranslation();
  const { detail = {}, end_at, points } = props;
  const priceStyle = useMemo(() => {
    let size = String(detail.currency + detail.price).length;
    if (size < 4) {
      return { fontSize: "34px" };
    } else if (size >= 4 && size <= 6) {
      return { fontSize: "26px" };
    } else {
      return { fontSize: "18px" };
    }
  }, [detail.currency, detail.price]);
  const isSelected = useMemo(() => {
    return (props.selected || []).includes(props.code);
  }, [props.selected, props.code]);
  const Price = () => {
    switch (detail.price_type) {
      case "percentage":
        return <span>{detail.price_humanize}</span>;
        break;
      case "fixed":
        return (
          <React.Fragment>
            <i>{detail.currency}</i>
            <span style={priceStyle}>{detail.price_humanize}</span>
          </React.Fragment>
        );
        break;
      case "none":
        return (
          <React.Fragment>
            <i>{detail.currency}</i>
            <span style={priceStyle}>{detail.price_humanize}</span>
          </React.Fragment>
        );
        break;
      default:
        return (
          <span
            style={{
              fontSize: 18,
              width: 100,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {detail.title}
          </span>
        );
        break;
    }
  };
  return (
    <div className="buydeal-voucher-card">
      <div
        className={`buydeal-voucher-card--body ${
          !(
            props.applicable ||
            props.applicable === undefined ||
            props.applicable === null
          )
            ? "buydeal-voucher-card--body--disabled"
            : ""
        }`}
      >
        <div style={{ display: "flex" }}>
          <div className="buydeal-voucher-card--left" hidden={props.hidden}>
            <DcCheckbox
              checked={isSelected}
              onChange={props.onChange}
            ></DcCheckbox>
          </div>
          <div
            className="buydeal-voucher-card--price"
            hidden={!+props.detail.price}
          >
            <Price />
          </div>
        </div>
        <div
          className="buydeal-voucher-card--right"
          style={{ maxWidth: !+props.detail.price ? "none" : "135px" }}
        >
          <div className="buydeal-voucher-card--title ellipsis-2">
            {detail.title}
          </div>
          {detail.visible_consumer && (
            <div className="buydeal-voucher-card--item">
              <label
                className={classNames("buydeal-voucher-card--item-date", {
                  "no-price": !+props.detail.price,
                })}
              >
                {t("VOUCHERS.Expires on")}:{" "}
              </label>
              {moment(end_at).format("YYYY-MM-DD")}
            </div>
          )}
          <div className="buydeal-voucher-card--item ellipsis-1">
            <label>{t("VOUCHERS.Redeems left")}: </label>
            <span>
              {detail.points_type === "unlimited"
                ? t("VOUCHERS.Unlimited")
                : points}
            </span>
          </div>
        </div>
      </div>
      <div className="buydeal-voucher-card--footer">
        <span className="terms-button" onClick={props.showTerm}>
          {t("VOUCHERS.Terms of use")}
          <i className="icon icon-info terms-icon"></i>
        </span>
        <span
          className="dc-tag"
          hidden={
            props.applicable ||
            props.applicable === undefined ||
            props.applicable === null
          }
        >
          {t("walkin.Not applicable")}
        </span>
      </div>
    </div>
  );
};

/**使用条款 */
export const Terms = ({ visible, setVisible, text }) => {
  const { t } = useTranslation();
  return (
    <Modal
      visible={visible}
      wrapClassName="dc-modal voucher-modal"
      zIndex={1011}
      width={300}
      footer={null}
      closable={false}
      centered
      destroyOnClose
    >
      <header>{t("VOUCHERS.Terms of use")}</header>
      <div className="voucher-modal--content">
        <div dangerouslySetInnerHTML={{ __html: text }}></div>
        <footer>
          <span></span>
          <strong onClick={() => setVisible(false)}>
            {t("VOUCHERS.Close")}
          </strong>
        </footer>
      </div>
    </Modal>
  );
};

export const DcCheckbox = (props) => {
  let { card, hidden, noIcon, checked } = props;
  const onChange = () => {
    props.onChange && props.onChange(!checked);
  };
  return (
    <div
      className="checkbox"
      data-card={card}
      data-error={props.errtip}
      onClick={onChange}
      hidden={hidden}
    >
      <div
        className="checkbox-icon"
        data-checked={checked}
        hidden={noIcon}
      ></div>
      <div className="checkbox-text">{props.children}</div>
    </div>
  );
};
